<template>
  <v-container>
    <c-card>
      <v-row class="pl-2" align="center">
        <v-col cols="10" class="pl-2">
          <v-row align="center">
            <v-menu
              v-model="notBeforeMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <div style="width: 200px">
                  <v-text-field
                    v-model="notBefore"
                    label="시작일"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </div>
              </template>
              <c-date-picker v-model="notBefore" @input="notBeforeMenu = false" firstDayOfWeek="1" :selectedDate="notBefore" locale="ko-kr"></c-date-picker>
            </v-menu>
            <v-menu
              v-model="notAfterMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <div class="ml-5" style="width: 200px">
                  <v-text-field
                    v-model="notAfter"
                    label="종료일"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </div>
              </template>
              <c-date-picker v-model="notAfter" @input="notAfterMenu = false" firstDayOfWeek="1" :selectedDate="notAfter" locale="ko-kr"></c-date-picker>
            </v-menu>
            <v-chip class="ml-2"> 총 {{ totalCount }} 건</v-chip>
          </v-row>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="2">
          <c-btn color="blue" outlined iconName="add" @click="dataAddDialog = true">내역추가</c-btn>
        </v-col>
        <v-col> <span> 주유 총량 : {{this.totalLiter.toLocaleString()}} L</span></v-col>
      </v-row>
      <div>
        <c-table :headers="tableHeaders" :items="tableItems">
          <template #date="{item}">
            {{item.date}} {{item.time}}
          </template>
          <template #liter="{item}">
            {{Number(item.liter).toLocaleString()}}
          </template>
          <template #price="{item}">
            {{ Number(item.price).toLocaleString() }}
          </template>
          <template #etc="{item}">
            <c-btn class="mx-1" icon iconName="mdi-pencil" @click="onUpdateInfo(item)" ></c-btn>
            <c-btn icon iconName="delete" @click="reqDeleteRefueling(item.id)"></c-btn>
          </template>
        </c-table>
      </div>
    </c-card>

    <refueling-c-u-dialog
      :open.sync="dataAddDialog"
      @reqAddRefueling=reqAddRefueling
      @reqUpdateRefueling="reqUpdateRefueling"
      :defaultInfo="defaultInfo"
    ></refueling-c-u-dialog>
  </v-container>
</template>

<script>
  import RefuelingCUDialog from './RefuelingCUDialog';

  export default {
    components: {RefuelingCUDialog},
    data() {
      return {
        notBeforeMenu: false,
        notAfterMenu: false,
        notBefore: this.$func.curDateStringAddDays(-30),
        notAfter : this.$func.curDateString(),
        dataAddDialog: false,
        tableHeaders: [
          {
            text:'일시',
            sortable: true,
            align:'center',
            value:'date'
          },
          {
            text:'주유량',
            sortable: true,
            align:'center',
            value:'liter'
          },
          {
            text:'주유소',
            sortable: true,
            align:'center',
            value:'gasStation'
          },
          {
            text:'금액 (원)',
            sortable: true,
            align:'center',
            value:'price'
          },
          {
            text:'',
            sortable: true,
            align:'center',
            value:'etc'
          },
        ],
        tableItems: [],
        defaultInfo : {},
        totalCount : 0,
        totalLiter : 0,
      }
    },
    watch:{
      notBefore() {
        this.reqRefuelingList()
      },
      notAfter() {
        this.reqRefuelingList()
      }
    },
    mounted() {
      this.reqRefuelingList();
    },
    methods:{
      async reqAddRefueling(data) {
        data['vehicleId'] = this.$route.params.vehicleId;
        const res = await this.$api.addRefueling(data);
        this.dataAddDialog = false;
        this.$store.commit('snackbar', {color: 'blue', msg: '주유내역이 추가되었습니다.'});

        this.reqRefuelingList();
      },
      async reqRefuelingList() {
        const res = await this.$api.getRefuelingList(this.$route.params.vehicleId, this.notBefore, this.notAfter);

        this.totalCount = res.data.length;
        this.tableItems = res.data;
        let totalLiter = 0;
        for(let idx in res.data){
          totalLiter += Number(res.data[idx].liter);
        }
        this.totalLiter = totalLiter;
      },
      onUpdateInfo(data) {
        this.defaultInfo = {...data};
        this.dataAddDialog = true;
      },
      async reqUpdateRefueling(data){
        const res = await this.$api.updateRefueling(data);
        this.$store.commit('snackbar', {color: 'blue', msg: '주유내역이 수정되었습니다.'});
        this.reqRefuelingList();
        this.dataAddDialog = false;
      },
      async reqDeleteRefueling(id) {
        await this.$api.deleteRefueling(id);
        this.$store.commit('snackbar', {color: 'blue', msg: '주유정보가 삭제되었습니다.'});
        this.reqRefuelingList();
      }
    }
  }
</script>

<style scoped>

</style>